export default __webpack_public_path__ + "static/media/fastener-placement-rectangle-squared-corners.6f5129eb.webp";